import { inject, InjectionToken, Provider } from '@angular/core';
import { SubmissionSignalState } from '@data-access/configurations';
import { SUBMISSION_SIGNAL_STORE } from '../signal-store';

export const SUBMISSION_TOKEN = new InjectionToken<SubmissionSignalState>(
  'SUBMISSION SIGNAL STORE TOKEN',
);

export const SUBMISSION_PROVIDER: Provider = {
  provide: SUBMISSION_TOKEN,
  useClass: SUBMISSION_SIGNAL_STORE,
};

export function submissionTokenizer() {
  return inject(SUBMISSION_TOKEN);
}
